import { useCreditPricing, formatCredits } from '../../hooks/useCreditPricing';
import type { CostItem } from './CreditCostNotice';
import { itemsTotal } from './pipelineCost';

interface Props {
  items: CostItem[];
  className?: string;
}

/**
 * Badge de custo estimado por execução de um pipeline personalizado.
 * Atualiza conforme o usuário adiciona/remove etapas no editor.
 */
export function PipelineCostBadge({ items, className }: Props) {
  const { getCost, getMeta, loading } = useCreditPricing();
  if (loading) return null;

  const total = itemsTotal(items, getCost);
  const detail = items
    .filter(it => it.qty > 0)
    .map(it => `${it.qty} ${it.label || getMeta(it.featureKey)?.unit || 'un.'}`)
    .join(' + ');

  return (
    <div className={`inline-flex flex-wrap items-center gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs text-emerald-800 ${className || ''}`}>
      <span>💰</span>
      <span className="font-semibold">Custo estimado por execução: {formatCredits(total)} crédito{total !== 1 ? 's' : ''}</span>
      {detail && !items.some(it => it.unitCredits != null) && <span className="text-emerald-600">({detail})</span>}
      {items.some(it => it.unitCredits != null) && <span className="text-emerald-600">(cobra o uso real de cada etapa)</span>}
    </div>
  );
}
